import React, { useEffect, useState } from "react";
import { Container, Text, Wrapper } from "./style";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Nav = ({ menu }) => {
  const nav = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState(null);
  const navHandler = (to) => {
    const temp = location.pathname.split("/");
    temp[temp.length - 1] = to;
    nav(temp.join("/"));
  };

  useEffect(() => {
    const url = location.pathname;
    setCurrent(url.split("/").at(-1));
  }, [location]);
  const language = useSelector(selectLanguage);

  return (
    <Wrapper>
      <Container>
        {menu.data.map((v, idx) => (
          <Text
            onClick={() => navHandler(v.menu_index.toString())}
            current={current === v.menu_index.toString()}
            key={v.id}
          >
            {language === "en" ? v.title : v.titleKR}
          </Text>
        ))}
      </Container>
    </Wrapper>
  );
};

export default Nav;
